import { OrganisationSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const OrganisationModel: SelectorModel = {
  name: 'organisations',
  getSelector: OrganisationSelectors.selectAllOrganisationsDictionary,
  isReady: OrganisationSelectors.selectIsReadyOrganisation
};
